export default __webpack_public_path__ + "static/TimeOff-ab8510b84716e5e2ab44c0b013bd1b9e.png";